import {
  CourseListItem,
  SchoolListItem,
  UserDetailsDTO,
  UserSearchResponse,
  UserOrgsResponse,
  UserOrgsRequest,
  ClassListItem,
  CountResult
} from "@beable/roster-backend-client-v1";

import RosterBackendService from "./RosterBackendService";

async function getClassWithStudentsAndteachers(
  siteId: number,
  orgId: string,
  classId: string
): Promise<ClassListItem | null> {
  const classResp = await RosterBackendService.getClassWithStudentsAndTeachers(
    siteId,
    orgId,
    classId
  );

  if (classResp.isOk() && classResp.value) {
    return classResp.value;
  }

  return null;
}

async function getUserDetails(userId: string): Promise<UserDetailsDTO | null> {
  const detailsResp = await RosterBackendService.getUserDetails(userId);

  if (detailsResp.isOk() && detailsResp.value) {
    return detailsResp.value;
  }

  return null;
}

async function getUserRole(userId: string): Promise<string | null> {
  const response = await RosterBackendService.getUserRole(userId);

  if (response.isOk() && response.value) {
    return response.value;
  }

  return null;
}


async function searchUsersByUsernameOrName(
  siteId: number,
  searchString: string
): Promise<UserSearchResponse | null> {
  const usersResp = await RosterBackendService.searchBySubstring(
    siteId,
    searchString
  );

  if (usersResp.isOk() && usersResp.value) {
    return usersResp.value;
  }

  return null;
}

async function getCoursesForSchool(
  schoolId: string,
  siteId: number
): Promise<CourseListItem[] | null> {
  const coursesResp = await RosterBackendService.getCoursesForSchool(
    schoolId,
    siteId
  );

  if (coursesResp.isOk() && coursesResp.value) {
    return coursesResp.value;
  }

  return null;
}

async function getClassesForCourse(
  courseId: string,
  siteId: number
): Promise<ClassListItem[] | null> {
  const classResp = await RosterBackendService.getClassesForCourse(
    courseId,
    siteId
  );

  if (classResp.isOk() && classResp.value) {
    return classResp.value;
  }

  return null;
}

async function schoolsWithAcademicYearsAndCourses(
  siteId: number
): Promise<SchoolListItem[] | null> {
  const schoolResp = await RosterBackendService.schoolsWithAcademicYearsAndCourses(
    siteId
  );

  if (schoolResp.isOk() && schoolResp.value) {
    return schoolResp.value;
  }

  return null;
}

async function getAdminsCountForSite(
  siteId: number
): Promise<CountResult | null> {
  const adminsResp = await RosterBackendService.getAdminsCountForSite(siteId);

  if (adminsResp.isOk() && adminsResp.value) {
    return adminsResp.value;
  }

  return null;
}

async function findUserOrgs(
  siteId: number,
  userId: string,
  academicYearId?: string
): Promise<UserOrgsResponse | null> {
  const req: UserOrgsRequest = {
    siteId,
    userId,
  };
  if(academicYearId) {
    req.academicYearId = academicYearId
  }
  const userOrgsResp = await RosterBackendService.findUserOrgs(req);

  if (userOrgsResp.isOk() && userOrgsResp.value) {
    return userOrgsResp.value;
  }

  return null;
}

export default {
  getClassWithStudentsAndteachers,
  getUserDetails,
  getUserRole,
  searchUsersByUsernameOrName,
  getCoursesForSchool,
  getClassesForCourse,
  schoolsWithAcademicYearsAndCourses,
  getAdminsCountForSite,
  findUserOrgs,
};
